export enum Mode{
  ADD,
  EDIT,
  VIEW
}

export enum Navigation{
  DETAILS = "Details",
  RULES = "Rules",
  RUN = "Test the report"
}

export const ReportMenus = [Navigation.DETAILS, Navigation.RULES];

export enum ParentType {
  ALL_PATIENTS = "all_patients",
  CURRENTLY_ACTIVE_PATIENTS = "currently_active_patients",
  PARENT_REPORT = "Based on Another Report"
}

export enum Module {
  PatientDetails = "demographics",
}

export enum PatientDetailsFeatureType {
  Age = "age",
  DateOfBirth = "date",
  Sex = "Sex",
}

